/* eslint jsx-a11y/aria-role: 0 */
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
/* reducers */
import { getCartQuantity, resetCart } from '../../reducers/cartReducer'
import { getFullName } from '../../reducers/customerReducer'
import * as menu from '../../reducers/menuReducer';
import * as page from '../../reducers/pageReducer';
import * as user from '../../reducers/userReducer';
import * as modal from '../../reducers/modalReducer';
import * as addressReducer from '../../reducers/addressReducer';

/* actions */
import { hideCart } from '../../actions/product';
import { setNavBarTitle } from '../../actions/view';
import { setHandleOrdersAfterLogin } from '../../reducers/paymentKioskReducer';

import {
  checkOutUri,
} from '../../config/uri';

import { isKioskMode as isKioskSelector } from '../../selectors/viewSelectors';
import { isKioskCustomerSelector } from '../../selectors/userSelectors';
import {
  isCartSelector,
  isSearch as isSearchSelector,
  isOnlineMenu as isOnlineMenuSelector,
  isPaymentKiosk as isPaymentKioskSelector,
  isMainBoard,
  getLogoUrlLink,
  getSearchIconColor,
  getHamburgerIconColor,
  getPurchaseLimitsIconColor,
  getCartIconColor,
  isPhoneSelector,
  isEcommerceSearchBarEnabled,
  isCustomerTypeOptionEnabled
} from '../../selectors/configSelectors';
import { toBool, getConfigValue } from '../../reducers/configReducer';
import { PURCHASE_RESTRICTIONS } from '../../config/const';
import { openPurchaseLimits } from '../../actions/purchase_limits_action';
import { isMenuPageOpen } from '../../selectors/page_selectors';
import { isPurchaseLimitsExceeded } from '../../selectors/summary_selectors';
import NavBar from './NavBar';
import { isProductsPage } from '../../helpers/urlParts';
import { isSalesChannelNameItemMismatch } from '../../selectors/cartSelectors';
import { pushWithQueryParams } from '../../services/uri';

const mapStateToProps = (state) => {
  return {
    allowRewardsRedemptionEcommerce: toBool(getConfigValue('ALLOW_REWARDS_REDEMPTION_ECOMMERCE', state)),
    isUser: user.isUser(state),
    rewardsDollars: user.getRewardsDollars(state),
    isKiosk: isKioskSelector(state),
    isOnlineMenu: isOnlineMenuSelector(state),
    isKioskCustomer: isKioskCustomerSelector(state),
    envName: state.view.env,
    navBarTitle: state.view.navBarTitle,
    customerFullName: getFullName(state),
    userFirstName: state.user.firstName,
    router: state.router,
    primaryColor: state.config.primaryColor,
    config: state.config,
    cartQuantity: getCartQuantity(state),
    detailView: state.detailView,
    updated: state.orders.updated,
    logo: state.config.NAV_BAR_LOGO,
    currentAddress: addressReducer.isAddressSelected(state),
    isCart: isCartSelector(state),
    isSearch: isSearchSelector(state),
    isPaymentKiosk: isPaymentKioskSelector(state),
    isMainBoard: isMainBoard(state),
    isPurchaseRestrictions: toBool(getConfigValue(PURCHASE_RESTRICTIONS, state)),
    logoUrlLink: getLogoUrlLink(state),
    searchIconColor: getSearchIconColor(state),
    hamburgerIconColor: getHamburgerIconColor(state),
    purchaseLimitsIconColor: getPurchaseLimitsIconColor(state),
    cartIconColor: getCartIconColor(state),
    isMenuOpen: isMenuPageOpen(state),
    isPurchaseLimitsExceeded: isPurchaseLimitsExceeded(state),
    isPhone: isPhoneSelector(state),
    isEcommerceSearchBarEnabled: isEcommerceSearchBarEnabled(state),
    isProductPage: isProductsPage(state.router.location.pathname),
    isCustomerTypeOptionEnabled: isCustomerTypeOptionEnabled(state),
    isSalesChannelNameItemMismatch: isSalesChannelNameItemMismatch(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetCart: () => dispatch(resetCart()),
    openConfirmModal: props =>
      dispatch(
        modal.openModal({
          modalType: "CONFIRM_MODAL",
          modalProps: props
      })
    ),
    openLoginForm: () => dispatch(modal.openModal({
      modalType: 'LOGIN_FORM',
      modalProps: {
        raisedClass: 'raise',
      }
    })),
    openLogOutForm: (props) => dispatch(
      modal.openModal({
        modalType: "LOGOUT_FORM",
        modalProps: props
      })
    ),
    openShippingForm: () =>
      dispatch(
        modal.openModal({
          modalType: "SHIPPING_FORM",
          modalProps: {}
        })
      ),
    openFilter: () => dispatch(modal.openModal({
      modalType: 'FILTER_MODAL',
      modalProps: {}
    })),
    openMenu: () => dispatch(page.openPage({
      pageType: 'MENU_PAGE',
      pageProps: {}
    })),
    openPurchaseLimitsForm: () => dispatch(openPurchaseLimits()),
    menuClick: (isMenuOpened) => dispatch(menu.menuClick(isMenuOpened)),
    hideMenu: () => dispatch(page.hidePage()),
    showCart: () => dispatch(pushWithQueryParams(checkOutUri)),
    go: (uri) => dispatch(pushWithQueryParams(uri)),
    goBack: () => dispatch(goBack()),
    hideCart: () => dispatch(hideCart()),
    setNavBarTitle: (title) => dispatch(setNavBarTitle(title)),
    hideDetail: () => dispatch({ type: 'HIDE_DETAIL_VIEW' }),
    setHandleOrdersAfterLogin: (shouldHandle) => dispatch(setHandleOrdersAfterLogin(shouldHandle))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar/nav_bar_container.jsx